// Shows the sticky add-to-cart bar once the real buy box ([data-buy-box])
// scrolls out of view, hides it again once the buy box is back in view.
class StickyCartBar extends HTMLElement {
  connectedCallback() {
    const buyBox = document.querySelector('[data-buy-box]');
    if (!buyBox) return;
    const observer = new IntersectionObserver(([entry]) => {
      this.classList.toggle('hidden', entry.isIntersecting);
    });
    observer.observe(buyBox);
  }
}

customElements.define('sticky-cart-bar', StickyCartBar);
